import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components';
import { Card, Col, Row, Image, Button } from 'react-bootstrap';
import { StarIcon, CCSMALL, CSSMALL, DASMALL, ITSMALL } from '../../../../../components/icons';
import Cloud from '../../../../../assets/CloudComputing.png';
import Security from '../../../../../assets/CyberSecurity.png';
import DataAnalytics from '../../../../../assets/DataAnalytics.png';
import ITHelpDesk from '../../../../../assets/IThelpDesk.png';
import { useHistory } from 'react-router-dom';


const ImagebyCategory = {
    Cloud: {
        Image: Cloud,
        Name: 'Cloud Computing'
    },
    Security:{
        Image: Security,
        Name: 'Cyber Security'
    },
    DataAnalytics:{
        Image: DataAnalytics,
        Name: 'Data Analytics'
    },
    ITHelpDesk: {
        Image: ITHelpDesk,
        Name: 'IT Help Desk'  
    },
}

const CategoryTitleCard = styled.div`
    font-size: 25px;
    color: white;
    margin-top: 15%;
    margin-bottom: 15%;
    font-weight: 600;
    line-height: 30px;
    text-transform: uppercase;
`;

function CategoryBoard({JobList, Category}) {

    const [viewJobs, setviewJobs] = useState([]);
    const history = useHistory();

    const loadMoreJobs = () => {
        if(viewJobs.length != JobList.length) {
            setviewJobs(JobList);
        }
        else {
            setviewJobs(JobList.slice(0,8));
        }
    }

    useEffect(() => {
        setviewJobs(JobList.slice(0,8));
    },[]);

    const getCategorySmallIcon = () => {
        if(Category === 'Cloud') {
            return <CCSMALL  height ='45px' width='45px' />
        } else if(Category === 'Security') {
            return <CSSMALL  height ='45px' width='45px' />
        }
        else if(Category === 'DataAnalytics') {
            return <DASMALL  height ='45px' width='45px' />
        }else {
            return <ITSMALL  height ='45px' width='45px' />
        }
    }

    const jobListView = (job, index) => {
        return ( 
                <Col md={3} sm={3} xs={3} style={{marginBottom:'20px'}} key={index}>
                    <Row>
                        <Col sm={2} md={2} xs={2}>{getCategorySmallIcon()}</Col>
                        <Col style={{marginLeft:'5%'}}>
                            <div style={{fontSize:'14px', fontWeight: '700'}}>{job.Title}</div>
                            <div style={{fontSize:'12px', color:'gray'}}>                                                
                                <div>{job.CompanyName}</div>
                                <div>{job.Location}</div>
                                <div style={{color: 'red', fontWeight: '700', cursor: 'pointer'}} onClick={() => {
                                    history.push('/Job/'+job.JobId)
                                }}>Apply Now!</div>
                            </div>
                        </Col>
                    </Row>
                </Col>);
    }

    return viewJobs.length && (
        <div>
            <StarIcon  fill="#FC1D24" style={{width:'50px',height:'50px', position:' absolute', marginTop: '-20px', marginLeft: '-35px'}} />
                <Row style={{borderBottom: '1px solid #2E3192'}}>
                    <Col style={{maxWidth: '170px', backgroundColor: '#2E3192'}}>
                        <p className='text-center text-warning'>
                            <CategoryTitleCard>{ImagebyCategory[Category]?.Name}</CategoryTitleCard>
                            <Image src={ImagebyCategory[Category]?.Image} style={{width: '60%'}} />
                        </p>
                    </Col>
                    <Col>
                        <Row>
                            <Row style={{margin: '10px 0px 10px 0px'}}>
                                {
                                viewJobs.map((job, index) => {
                                    return jobListView(job, index);
                                })
                                }
                               {
                                   JobList.length > 8 &&
                                   <Button className='float-right' variant="secondary" onClick={loadMoreJobs}> See {
                                    viewJobs.length == JobList.length ? 'Less' : 'More'
                                    } Jobs</Button> 
                               }
                               
                            </Row>
                        </Row> 
                    </Col>                   
                </Row>
        </div>
    )
}

CategoryBoard.propTypes = {
    JobList: PropTypes.arrayOf({
        Title: PropTypes.string,
        CompanyName: PropTypes.string,
        Location: PropTypes.string
    }),
    Category: PropTypes.string
}

export default CategoryBoard

